module.exports = __webpack_public_path__ + "static/media/img_mobile_brand_b_bg.1feb63f9.png";